const onScroll = () => {
  const body = document.querySelector("body");
  const headerColor = body.getAttribute("data-header-color");
  const windowHeight = window.innerHeight - 73;

  const maskScroll = document.querySelector(".mask__scroll");
  const logoContainer = document.querySelector(".logo");
  const logoFull = document.querySelector(".logo__full");
  const logoShort = document.querySelector(".logo__short");

  let lastKnownScrollPosition = 0;
  let ticking = false;

  // const toggleGradient = () => {
  //   maskScroll.classList.toggle("mask--open", lastKnownScrollPosition > 0);
  // };

  function elementHasClass(element, className) {
    return element.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(element.className);
}

  const toggleLogo = () => {
    if (!!logoFull && lastKnownScrollPosition < 552) {
      logoFull.style.opacity =
        (90 - lastKnownScrollPosition * 0.247978437) / 100;
      logoShort.style.opacity =
        (lastKnownScrollPosition - 120) * 0.247978437 / 100;

      90 - 100;
    }
  };

  const toggleNavColor = () => {
    if (!elementHasClass(document.querySelector('body'), 'single-exhibition')) {
      body.classList.toggle(
        `header-color--${headerColor}`,
        windowHeight * 0.9 > lastKnownScrollPosition
      );
    }
  };

  const scrollEventListener = event => {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        // toggleGradient();
        toggleLogo();
        toggleNavColor();
        ticking = false;
      });

      ticking = true;
    }
  };

  window.addEventListener("scroll", scrollEventListener);
};

const Header = function() {
  const body = document.querySelector("body");
  const header = document.querySelector(".header");
  const menu = document.querySelector(".header__nav.nav.nav__primary ul.nav__listing");
  const content = document.querySelector(".content");

  onScroll();

  menu.addEventListener(
    "mouseenter",
    event => {
      body.classList.add("showing-navigation");
    },
    false
  );

  menu.addEventListener(
    "mouseleave",
    event => {
      body.classList.remove("showing-navigation");
    },
    false
  );
};

module.exports = Header;
